import React, { PureComponent } from "react";
import { Cell, Legend, Pie, PieChart, ResponsiveContainer } from "recharts";

const colors = ["#900084", "#8FB100"];

export class SectionalCountry extends PureComponent {
    render() {
        const { data } = this.props;
        const sum = data.reduce((total, entry) => total + entry.Valor, 0);

        return (
            <div>
                <ResponsiveContainer width="100%" height={400}>
                    <PieChart width={400} height={400}>
                        <Pie
                            data={data}
                            dataKey="Valor"
                            nameKey="Nombre"
                            cx="50%"
                            cy="50%"
                            innerRadius={20}
                            outerRadius={80}
                            fill="#8884d8"
                            // labelLine={false}
                            label={({ cx, cy, midAngle, innerRadius, outerRadius, percent, index, name, value }) => {
                                const RADIAN = Math.PI / 180;
                                const radius = 25 + innerRadius + (outerRadius - innerRadius);
                                const x = cx + radius * Math.cos(-midAngle * RADIAN);
                                const y = cy + radius * Math.sin(-midAngle * RADIAN);
                                return (
                                    <text x={x} y={y} fill={colors[index % colors.length]} textAnchor={x > cx ? "start" : "end"} dominantBaseline="central">
                                        <tspan x={x} dy="0em">{name}</tspan>
                                        <tspan x={x} dy="1.2em">{`${value} (${(percent * 100).toFixed(2)}%)`}</tspan>
                                    </text>
                                );
                            }}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                            ))}
                        </Pie>
                        <Legend />
                    </PieChart>
                </ResponsiveContainer>
                <div>Total: {sum}</div>
            </div>
        );
    }
}
